import Step from "../types/Step";
import getStepPath from "./getStepPath";

export default function stepsEqual(a: Step[], b: Step[]) {
    return a.map(getStepPath).join(',') === b.map(getStepPath).join(',')
};